import axiosInstance from './axiosInstance';

const dataService = {
  editData: async (data) => {
    try {
      const response = await axiosInstance.post('/data/edit', data);
      return response.data;
    } catch (error) {
      console.error('Error editing data:', error.response?.data || error.message);
      throw error;
    }
  },
  getData: async () => {
    try {
      const response = await axiosInstance.post('/data/get-data');
      return response.data.data;
    } catch (error) {
      console.error('Error editing data:', error.response?.data || error.message);
      throw error;
    }
  },
  // New method: Upload file to GCP
  getGCPFileUrl: async (file) => {
    try {
      // 1️⃣ Get the signed URL from the backend
      const { data } = await axiosInstance.post('/data/create-document', {
        filename: file.name,
        contentType: file.type,
      });
      return {url:data.url, filePath: data.filePath};
    } catch (error) {
      console.error('Error uploading file to GCP:', error.response?.data || error.message);
      throw error;
    }
  },
  saveFileToDb: async (data) => {
    try {
      const response = await axiosInstance.post('/data/save-document', data);
      return response.data;
    } catch (error) {
      console.error('Error saving file to DB:', error.response?.data || error.message);
      throw error;
    }
  },
  fetchUserFiles: async () => {
    try {
      const response = await axiosInstance.post('/data/list-files', {});
      return response.data.files;
    } catch (error) {
      console.error('Error saving file to DB:', error.response?.data || error.message);
      throw error;
    }
  }

};

export default dataService;
